import React from 'react';
import { MenuFavoriteItem } from './MenuFavoriteItem';
import { MenuMyHubItem } from './MenuMyHubItem';
import { MenuListItem } from './MenuListItem';

const renderMenuItem = (
  isMyHubRoute,
  isFavoriteRoute,
  isExpandedMyHubSection,
  isExpandedFavoriteSection,
  isExpandedRoute,
  myHubRoutes,
  Icon,
  handleClick,
  onCloseMenu,
  route,
  open
) => {
  if (isFavoriteRoute) {
    return (
      <MenuFavoriteItem
        route={route}
        open={open}
        isExpanded={isExpandedFavoriteSection}
        onCloseMenu={onCloseMenu}
      />
    );
  }

  if (isMyHubRoute) {
    return (
      <MenuMyHubItem
        route={route}
        routes={myHubRoutes}
        open={open}
        isExpanded={isExpandedMyHubSection}
        onCloseMenu={onCloseMenu}
      />
    );
  }

  return (
    <MenuListItem
      route={route}
      Icon={Icon}
      isExpandedRoute={isExpandedRoute}
      handleClick={handleClick}
    />
  );
};

export { renderMenuItem };
